// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/account_management/api/organizations/deactivations/firstparty/v3/notice_period.proto

/* oxlint-disable */

/** Notice period of the deactivation request. */
export const ApiNoticePeriod = {
  /**
   * NOTICE_PERIOD_UNSPECIFIED - Default unspecified notice period.
   */
  NOTICE_PERIOD_UNSPECIFIED: "NOTICE_PERIOD_UNSPECIFIED",
  /**
   * immediate - Immediate deactivation.
   */
  immediate: "immediate",
  /**
   * end_of_the_month - Deactivation at the end of the current month.
   */
  end_of_the_month: "end_of_the_month",
  /**
   * seven_days - Seven days notice period.
   */
  seven_days: "seven_days",
  /**
   * ten_days - Ten days notice period.
   */
  ten_days: "ten_days",
  /**
   * fifteen_days - Fifteen days notice period.
   */
  fifteen_days: "fifteen_days",
  /**
   * twenty_days - Twenty days notice period.
   */
  twenty_days: "twenty_days",
  /**
   * thirty_days - Thirty days notice period.
   */
  thirty_days: "thirty_days",
  /**
   * sixty_days - Sixty days notice period.
   */
  sixty_days: "sixty_days",
  /**
   * ninety_days - Ninety days notice period.
   */
  ninety_days: "ninety_days",
  /**
   * end_sdd_refund_period - Deactivation at the end of the SDD refund period.
   */
  end_sdd_refund_period: "end_sdd_refund_period",
  /**
   * one_day - One day notice period.
   */
  one_day: "one_day",
} as const;

export type ApiNoticePeriod = typeof ApiNoticePeriod[keyof typeof ApiNoticePeriod];

export namespace ApiNoticePeriod {
  export type NOTICE_PERIOD_UNSPECIFIED = typeof ApiNoticePeriod.NOTICE_PERIOD_UNSPECIFIED;
  export type immediate = typeof ApiNoticePeriod.immediate;
  export type end_of_the_month = typeof ApiNoticePeriod.end_of_the_month;
  export type seven_days = typeof ApiNoticePeriod.seven_days;
  export type ten_days = typeof ApiNoticePeriod.ten_days;
  export type fifteen_days = typeof ApiNoticePeriod.fifteen_days;
  export type twenty_days = typeof ApiNoticePeriod.twenty_days;
  export type thirty_days = typeof ApiNoticePeriod.thirty_days;
  export type sixty_days = typeof ApiNoticePeriod.sixty_days;
  export type ninety_days = typeof ApiNoticePeriod.ninety_days;
  export type end_sdd_refund_period = typeof ApiNoticePeriod.end_sdd_refund_period;
  export type one_day = typeof ApiNoticePeriod.one_day;
}

export function apiNoticePeriodFromJSON(object: any): ApiNoticePeriod {
  switch (object) {
    case 0:
    case "NOTICE_PERIOD_UNSPECIFIED":
      return ApiNoticePeriod.NOTICE_PERIOD_UNSPECIFIED;
    case 1:
    case "immediate":
      return ApiNoticePeriod.immediate;
    case 2:
    case "end_of_the_month":
      return ApiNoticePeriod.end_of_the_month;
    case 3:
    case "seven_days":
      return ApiNoticePeriod.seven_days;
    case 4:
    case "ten_days":
      return ApiNoticePeriod.ten_days;
    case 5:
    case "fifteen_days":
      return ApiNoticePeriod.fifteen_days;
    case 6:
    case "twenty_days":
      return ApiNoticePeriod.twenty_days;
    case 7:
    case "thirty_days":
      return ApiNoticePeriod.thirty_days;
    case 8:
    case "sixty_days":
      return ApiNoticePeriod.sixty_days;
    case 9:
    case "ninety_days":
      return ApiNoticePeriod.ninety_days;
    case 10:
    case "end_sdd_refund_period":
      return ApiNoticePeriod.end_sdd_refund_period;
    case 11:
    case "one_day":
      return ApiNoticePeriod.one_day;
    default:
      return ApiNoticePeriod.NOTICE_PERIOD_UNSPECIFIED;
  }
}

export function apiNoticePeriodToJSON(object: ApiNoticePeriod): string {
  switch (object) {
    case ApiNoticePeriod.NOTICE_PERIOD_UNSPECIFIED:
      return "NOTICE_PERIOD_UNSPECIFIED";
    case ApiNoticePeriod.immediate:
      return "immediate";
    case ApiNoticePeriod.end_of_the_month:
      return "end_of_the_month";
    case ApiNoticePeriod.seven_days:
      return "seven_days";
    case ApiNoticePeriod.ten_days:
      return "ten_days";
    case ApiNoticePeriod.fifteen_days:
      return "fifteen_days";
    case ApiNoticePeriod.twenty_days:
      return "twenty_days";
    case ApiNoticePeriod.thirty_days:
      return "thirty_days";
    case ApiNoticePeriod.sixty_days:
      return "sixty_days";
    case ApiNoticePeriod.ninety_days:
      return "ninety_days";
    case ApiNoticePeriod.end_sdd_refund_period:
      return "end_sdd_refund_period";
    case ApiNoticePeriod.one_day:
      return "one_day";
    default:
      return "NOTICE_PERIOD_UNSPECIFIED";
  }
}
